module.exports = [{"type":"title","text":"2024-11-07"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"永續幣本位：下單接口TimeInForce字段新增PostOnly類型。"},{"type":"html","text":"永續幣本位：查詢單個接口新增TimeInForce字段。"},{"type":"html","text":"永續幣本位：查詢委託中所有訂單接口新增TimeInForce字段。"},{"type":"html","text":"永續幣本位：查詢強平訂單接口新增TimeInForce字段。"},{"type":"html","text":"永續幣本位：查詢所有歷史訂單接口新增TimeInForce字段。"},{"type":"html","text":"永續U本位Websocket服務：‘訂單推送’增加td和tv字段。"},{"type":"html","text":"永續U本位：‘調整逐倉保證金’接口支持按positionId調整。"},{"type":"html","text":"永續U本位：新增‘領取VST’接口。"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/changelog/2024-11-07.json
// module id = R99K
// module chunks = 3